<template>
  <ActivityBody/>
</template>

<script>
// @ is an alias to /src
import ActivityBody from '@/components/ActivityBody.vue'

export default {
  name: 'ActivityView',
  components: {
    ActivityBody
  }
}
</script>
